/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/v_l2_norm.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Calculates the l2 norm between two dense_vectors.',
  examples: [
    'from colors\n| eval similarity = v_l2_norm(rgb_vector, [0, 255, 255])\n| sort similarity desc, color asc',
  ],
  params: {
    left: 'first dense_vector to calculate l2 norm similarity',
    right: 'second dense_vector to calculate l2 norm similarity',
  },
};

export default docs;
